import React, { Component } from 'react'; 
import Toggle from "react-toggle";
import axios from '../../../../../axios';
import * as url from '../../../../../utils/url';
import findIndex from 'lodash/findIndex';
import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../../../../modules/actions/index';
import moment from 'moment';
import {groupContentFields,eventRoles,  groupPrivacyStatusDesc,uploadPreview,whiteLabelStyling, profilePicValidityCheck} from  '../../../../../utils/constants';
import { Modal, ModalBody,ModalHeader, Alert, Button, Label, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Row, Col, Input } from 'reactstrap'
import Select from 'react-select';
import Loading from '../../../../../hoc/Loading/Loading';
import './AttendeeItem.css'



class AttendeeItem extends Component {
  constructor(props) {
    super(props);
    this.state = {   
      menu:'',
      members:[],
      dropdownOpen:false,
      isSuccess:false,
      removedItem:null,
      isRemoved:false,
      member:this.props.single_member, 
      role:this.props.single_member.role,
      currentUserRole: this.props.currentUserRole&&this.props.currentUserRole[0]&&this.props.currentUserRole[0].role?
      this.props.currentUserRole[0].role: 10000,
      group:this.props.group
    }
  }

 


  removeMember= (user) =>{
      let payload = {
        organizationId:this.props.group.organizationId,
        groupId:this.props.group._id,
        userId:user.userId,
        noLoader:true
      };

      let that=this;

      this.setState({isRemoved:true})
      axios.post(url.removeGroupMembers, payload).then(({ data }) => {	
        that.setState({ 
          removedItem:user,
          // isRemoved:true,
          isSuccess:true,
        })
      });
  }

  viewMember=user=>{
    let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.userId}`
    this.props.history.push(link);
  }

  getInitials=(user)=>{
    let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
    let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
    return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
  }



  handleRoleChange = (role) => {
    console.log('role------', role)
    let payload = {
        role,
        groupId: this.props.group._id,
        userId: this.state.item.userId,
        organizationId: this.props.group.organizationId,
        noLoader:true,
    }
    this.setState({role})
    let that=this
    axios.post(url.changeGroupRole, payload).then(({ data }) => {	
      // that.setState({ 
      // })
    });
  
  }

  onDismiss=()=>{
    this.setState({isSuccess:false, removedItem:null})
  }

  renderMembers = (tasks) => {
  const { orgAdmin } = this.props.user.profile;
  let{members,currentUserRole,removedItem,isRemoved,member,group,role}=this.state
    let{userId}=member
  if(isRemoved!=true){
      return (
        <li className={`table-row ${isRemoved?'':''}`} key={userId._id}>
          <div className="col col-6" data-label="Name">
           
            <div className="grp_member_profile_image">
                {profilePicValidityCheck(userId.profilePic)?
                <div className="list-item__avatar">
                  <img src={userId.profilePic} />
                </div>
                  :
                      <span className="list-item__avatar" data-letters={this.getInitials(userId)}></span>
                    }
              </div>

              <div className="grp_member_profile_details">
                
                <div className="linkedToolView" onClick={()=>this.viewMember(userId)}> {userId.firstName} ,  {userId.lastName}</div>
                
                <div className="grp_member_profile_joined">joined {moment(member.date).format('MMM Do, YYYY')} </div>
                
              </div>
          
          </div>
          
          <div className="col col-5" data-label="Role">
          
              <Select
              name="role-select"
              value={role}
              onChange={(r) => this.handleRoleChange(r)}
              options={eventRoles.filter(e=>e.isHidden!=true)}
              // valueKey='key'
              // labelKey='value'
              clearable={false}
              disabled={false}
          />
           
            {/* {item.role?item.role:'member'} */}
            </div>
          
       
          <div className="col col-1 remove-group-member" data-label="">
            <span onClick={()=>this.removeMember(userId)} className='chart-item-menu flaticon-trash'/> 
            {/* Remove  */}
          </div>
      </li>

       
            )
      } else {
        return <span className="hide"/>
      }
};



render() {
  return  this.renderMembers();
  }
}










const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
  
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(AttendeeItem, axios)));